/**
 * An error thrown by the `assert` function when the condition is false.
 */
export class AssertionError extends Error {
	constructor(message: string) {
		super(message);
		this.name = 'AssertionError';
	}
}
